<template lang='pug'>
  header.Header
    b-navbar.Header-nav.site-header.sticky-top.py-0.navbar-dark(toggleable='lg')
      .container
        b-navbar-toggle(target='nav-collapse')
        router-link.Header-mobile( :to="{ name: 'Startseite' }" tag="b-navbar-brand") Rechtsanwalt Christoph Schommer
        b-collapse#nav-collapse(is-nav)
          b-navbar-nav.Header-list
            router-link.Header-item( :to="{ name: 'Startseite' }" tag='b-nav-item' class='Header-item' active-class='active' exact) Startseite

            router-link.Header-item( :to="{ name: 'Kanzleiprofil' }" tag='b-nav-item' active-class='active' exact) Kanzleiprofil

            b-nav-item-dropdown.Header-item( text='Tätigkeitsfelder')
              router-link.Header-dropdown-item( :to="{ name: 'Baurecht' }" tag='b-dropdown-item' active-class='active' exact) Privates Baurecht
              router-link.Header-dropdown-item( :to="{ name: 'Architektenrecht' }" tag='b-dropdown-item' active-class='active' exact) Architektenrecht
              //- router-link.Header-dropdown-item( :to="{ name: 'Zivilrecht' }" tag='b-dropdown-item' active-class='active' exact) Zivilrecht
              li.Header-dropdown-item.disabled(tag='b-dropdown-item')
                a.dropdown-item.disabled(href="#") Zivilrecht

            router-link.Header-item( :to="{ name: 'Honorare' }" tag='b-nav-item' active-class='active' exact) Honorare
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style lang='stylus'>
  .Header {
    background-color $primary
    box-shadow 0px 1px 5px #222
    color $primary-text

    +below('m') {
      padding .5em 0
    }

    +at('m', orientation: landscape) {
      padding .5em 0 0
    }

    &-nav {
      margin auto
      width 100%
    }

    &-mobile {
      font-size 14px

      +above('l') {
        display none
      }
    }

    &-list {
      +at('m') {
        flex-direction row
      }
      +at('m', orientation: portrait) {
        transform translateY(0.5em)
      }
    }

    &-item {
      padding 12px 9px

      border-bottom 2px solid transparent

      color $white
      text-decoration none
      font-size 15px

      +below('s') {
        text-align left
        margin-left 0
      }

      .nav-link {
        color $white!important
        padding 0!important
      }

      span {
        color $white!important
      }

      .dropdown-menu {
        +at('m') {
          position absolute
        }
      }

      &.active {
        border-bottom 2px solid $quaternary

        +below('s') {
          border-bottom none

          &:after {
            position absolute
            content ''
            display block
            width 40px
            height 2px
            margin-top 6px
            background-color $quaternary
          }
        }
      }
    }

    .dropdown-menu {
      margin -.075em 0 0
    }

    &-dropdown-item {
      width 100%
      margin 0
      color $black

      &.active {
        background-color $primary--light
        .dropdown-item {
          color $white!important

          &:hover {
            background-color transparent
            color $white!important
          }
        }
      }

      &.disabled {
        cursor default
        a {
          cursor default
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/page/Header.vue